import { t } from "i18next"
import * as z from "zod"
import { stringRequired, textAreaDefaultMaxLength } from "@/models/common"
import { Language } from "@/types/__generated__/union-types"

export const generalAttestationSchema = z.object({
  language: z.custom<Exclude<Language, "ENGLISH">>(),
  to: stringRequired.max(200, { message: t("common.fieldErrorList.characterLimit") }),
  subject: stringRequired.max(200, { message: t("common.fieldErrorList.characterLimit") }),
  message: stringRequired.max(textAreaDefaultMaxLength, { message: t("common.fieldErrorList.characterLimit") }),
})

export type GeneralAttestationForm = z.infer<typeof generalAttestationSchema>
